const getDefaultState = () => {
  return {
    hasNewMessage: false,
    messages: []
  }
}

// const state = getDefaultState()

const module = {
  namespaced: true,
  state: {
    hasNewMessage: false,
    messages: []
  },
  getters: {
    getHasNewMessage: state => state.hasNewMessage,
    getMessages: state => state.messages
  },
  mutations: {
    addMessage (state, data) {
      state.messages.unshift(data)
    },
    changeHasNewMessage (state, data) {
      state.hasNewMessage = data
    },
    toggleMessageRead (state, data) {
      data.message.unread = !data.read
    },
    deleteAll (state) {
      state.messages = []
    },
    delete (state, data) {
      let index = state.messages.indexOf(data)
      if (index !== -1) {
        state.messages.splice(index, 1)
      }
    },
    RESET_STORE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    addMessage ({ commit }, message) {
      message.unread = true
      commit('changeHasNewMessage', true)
      commit('addMessage', message)
    },
    registerMessageCenterOpen ({ commit }) {
      commit('changeHasNewMessage', false)
    },
    toggleMessageRead ({ commit }, { message, read }) {
      commit('changeHasNewMessage', false)
      commit('toggleMessageRead', { message, read })
    },
    deleteAll ({commit}) {
      commit('changeHasNewMessage', false)
      commit('deleteAll')
    },
    deleteMessage ({commit}, message) {
      commit('changeHasNewMessage', false)
      commit('delete', message)
    }
  }
}

export default module
